import {
  chakra,
  Box,
  Center,
  Heading,
  Text,
  Image,
  UnorderedList, ListItem
} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';

export default function Links() {
  return (
    <chakra.section mt={`${71.2/16}rem`} pb="8rem">
      <Box textAlign="center" maxW={['contentSm', 'contentSm', 'content']} mx="auto">
        <Heading className="marker-yellow" display="inline-block" fontSize={['1.25rem', '1.25rem', "1.5rem"]} letterSpacing="0.1em" color="blue.500">
          このページをSNSでシェアする
        </Heading>
        <Text mt="5" fontSize="1rem" color="gray.500" textAlign={['start', 'start', 'inherit']}>※生成した“わたしの分人”円グラフ画像はシェアされません</Text>
        <UnorderedList display="flex" justifyContent="center" w="16.25rem" h="20" mt="4.5" mx="auto" listStyleType="none" gap="2.5">
          <ListItem w="auto">
            <chakra.a href="https://twitter.com/share?url=https%3A%2F%2Fdividualism.k-hirano.com&text=%23%E5%88%86%E4%BA%BA%E4%B8%BB%E7%BE%A9%20%23%E3%82%8F%E3%81%9F%E3%81%97%E3%81%AE%E5%88%86%E4%BA%BA%20" target="Twitter" h="100%">
              <Image src={`${IMAGE_PREFIX}btn-graph-sns-tw.png`} alt="Twitter" h="100%" />
            </chakra.a>
          </ListItem>
          <ListItem w="auto">
            <chakra.a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdividualism.k-hirano.com" target="Facebook" h="100%">
              <Image src={`${IMAGE_PREFIX}btn-graph-sns-fb.png`} alt="Facebook" h="100%" />
            </chakra.a>
          </ListItem>
          <ListItem w="auto">
            <chakra.a href="https://line.me/R/msg/text/?%23%E5%88%86%E4%BA%BA%E4%B8%BB%E7%BE%A9%20%23%E3%82%8F%E3%81%9F%E3%81%97%E3%81%AE%E5%88%86%E4%BA%BA%20%20https%3A%2F%2Fdividualism.k-hirano.com" target="LINE" h="100%">
              <Image src={`${IMAGE_PREFIX}btn-graph-sns-line.png`} alt="LINE" h="100%" />
            </chakra.a>
            </ListItem>
        </UnorderedList>
      </Box>
      <Center className="btn-large btn-blue" mt="2.375rem">
        <chakra.a href="/" _after={{display: 'none'}}>トップへ戻る</chakra.a>
      </Center>
    </chakra.section>
  );
}
